import { useInView } from '@/hooks/useInView';
import { X, Check, ArrowRight } from 'lucide-react';

const vorher = [
  'Keine oder veraltete Website',
  'Nicht mobilfähig',
  'Kein SSL-Zertifikat',
  'Teure Agenturverträge',
  'Wochen bis zur Fertigstellung',
  'Komplizierte Baukästen',
];

const nachher = [
  'Moderne, professionelle Webpräsenz',
  'Optimiert für alle Geräte',
  'SSL & Hosting inklusive',
  'Transparente Flatrate',
  'In wenigen Tagen live',
  'Wir kümmern uns um alles',
];

export default function VorherNachherSection() {
  const [ref, inView] = useInView();

  return (
    <section ref={ref} data-testid="vorher-nachher-section" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className={`text-center mb-16 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-purple-600 font-['Outfit']">Der Unterschied</span>
          <h2 className="mt-4 text-4xl sm:text-5xl font-light tracking-tight text-slate-900 font-['Outfit']">
            Vorher. <span className="gradient-text font-normal">Nachher.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto">
          {/* Vorher */}
          <div className={`bg-white/60 backdrop-blur-2xl border border-white/80 shadow-[0_8px_32px_rgba(0,0,0,0.04)] rounded-3xl p-8 transition-all duration-700 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`} data-testid="vorher-card">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-red-50 border border-red-100 mb-6">
              <div className="w-2 h-2 rounded-full bg-red-400" />
              <span className="text-xs font-semibold text-red-500 tracking-wider uppercase font-['Outfit']">Vorher</span>
            </div>
            <ul className="space-y-4">
              {vorher.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="mt-0.5 w-5 h-5 rounded-full bg-red-50 flex items-center justify-center flex-shrink-0">
                    <X size={11} className="text-red-400" />
                  </div>
                  <span className="text-sm text-slate-500">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Nachher */}
          <div className={`bg-white/60 backdrop-blur-2xl border border-purple-200/50 shadow-[0_8px_32px_rgba(168,85,247,0.08)] rounded-3xl p-8 transition-all duration-700 delay-150 ${
            inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`} data-testid="nachher-card">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-gradient-to-r from-indigo-500/10 to-pink-500/10 border border-purple-200/50 mb-6">
              <div className="w-2 h-2 rounded-full bg-purple-500" />
              <span className="text-xs font-semibold text-purple-600 tracking-wider uppercase font-['Outfit']">Nachher mit JF-NEXUS</span>
            </div>
            <ul className="space-y-4">
              {nachher.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <div className="mt-0.5 w-5 h-5 rounded-full bg-gradient-to-br from-indigo-500/10 to-pink-500/10 flex items-center justify-center flex-shrink-0">
                    <Check size={11} className="text-purple-600" />
                  </div>
                  <span className="text-sm text-slate-700 font-medium">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className={`text-center mt-12 transition-all duration-700 delay-300 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <button
            onClick={() => document.getElementById('kontakt')?.scrollIntoView({ behavior: 'smooth' })}
            className="group inline-flex items-center gap-2 text-sm font-medium text-purple-600 hover:text-purple-700 transition-colors"
            data-testid="vorher-nachher-cta"
          >
            Jetzt wechseln
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
}
